import React, { useCallback, useEffect, useState } from "react";
import { getPropType } from "../helpers/getPropType.helper";
import { updateProps } from "../helpers/setPropValue.helper";
const PropsContext = /*#__PURE__*/React.createContext({
  propsFromBio: {},
  updatePropFromBio: () => null
});
const buildProps = (inheritedProps, propTypes) => {
  const propsObj = Object.entries(inheritedProps || {}).reduce((obj, _ref) => {
    let [key, value] = _ref;
    return {
      ...obj,
      [key]: {
        type: getPropType(propTypes, key, value) || "hidden",
        title: (typeof (propTypes === null || propTypes === void 0 ? void 0 : propTypes[key]) === "object" ? propTypes[key].title : key) || key,
        value
      }
    };
  }, {});
  if (propTypes) {
    Object.entries(propTypes).forEach(_ref2 => {
      let [key, value] = _ref2;
      if (typeof propsObj[key] === "undefined") {
        propsObj[key] = {
          type: (typeof value === "string" ? value : value.type) || "hidden",
          title: typeof value === "object" && value.title ? value.title : key,
          value: undefined
        };
      }
    });
  }
  return propsObj;
};
export const PropsProvider = _ref3 => {
  let {
    props: inheritedProps,
    propTypes,
    children
  } = _ref3;
  const [propsFromBio, setPropsFromBio] = useState(buildProps(inheritedProps, propTypes));
  const updatePropFromBio = useCallback((prop, value) => {
    setPropsFromBio(prevState => updateProps(prevState, prop, value));
  }, []);
  useEffect(() => {
    setPropsFromBio(buildProps(inheritedProps, propTypes));
  }, [inheritedProps, propTypes]);
  return /*#__PURE__*/React.createElement(PropsContext.Provider, {
    value: {
      propsFromBio,
      updatePropFromBio
    }
  }, children);
};
export const useProps = () => React.useContext(PropsContext);
//# sourceMappingURL=Props.hook.js.map